import { createStore } from '../.'

import type { StateStorage } from 'zustand/middleware'

interface BalanceChangesInterface {
  walletTotalBalanceChange: {
    [principalId: string]: number | undefined
  }
  setWalletBalanceChange: (principalId: string, change: number | undefined) => void
}

export const createBalanceChangesStore = (storage: StateStorage) =>
  createStore<BalanceChangesInterface>(
    storage,
    (set, get) => ({
      walletTotalBalanceChange: {},
      setWalletBalanceChange: (principalId, change) => {
        const { walletTotalBalanceChange } = get()

        set({
          walletTotalBalanceChange: {
            ...walletTotalBalanceChange,
            [principalId]: change,
          },
        })
      },
    }),
    {
      persist: {
        name: 'balanceChanges',
        version: 0,
      },
    }
  )
